import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup, Navbar, Breadcrumb } from "react-bootstrap";
import "../add-details.css";

import { connect } from "react-redux";
import { isEmpty, find, isUndefined, filter } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton } from "@material-ui/core";
import Select from "react-select";
import Swal from "sweetalert";
import { getVendorData } from "../Vendor/Vendor.action";
import { generatePurchaseReportItemWise, generateVendorReportPDF } from "./Receiving.action";
import { setHeading } from "../../../accounts/account.actions";
import IconMenu from "../../../drawer/IconMenu";
import { Link } from "react-router-dom";
import { getProductData } from "../AddProduct/Product.action";
// import { addReceiving, getPDFById, getReceiving } from "./Receiving.action";

const PurchaseVendorReport = (props) => {
  const [vendorId, setVendorId] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  function uploadPurchase() {
    //   props.getReceivingPdf(ReceivingId);
    props.generatePurchaseReportItemWise({
      startDate: startDate,
      endDate: endDate,
      vendorId: vendorId,
      productId: productId
    })
    setVendorId("");
    setVendorName("");
    setProductId("");
    setProductName("");
    // setStartDate("");
    // setEndDate("")
  }
  // vendorDataList
  const handleChangeVendor = (selectedOption) => {
    console.log(selectedOption, "sop");
    setVendorId(selectedOption.value);
    setVendorName(selectedOption.label);
  };
  const getVendorList =
    !isEmpty(props.vendorDataList) &&
    props.vendorDataList.map((x) => {
      let data = { value: x._id, label: x.vendorName };
      return data;
    });
  const filterdProductList =
    !isEmpty(props.productDataList) &&
    props.productDataList.filter((e) => e.vendorId == vendorId);

  const getMList =
    !isEmpty(filterdProductList) &&
    filterdProductList.map((x) => {
      let data = {
        value: x._id,
        label: `${x.code}-${x.name}`,
        productQuantityCount: x.productBalance,
        productPrice: x.purchasePrice,
        piecePerBox: x.piecePerBox,

      };
      return data;
    });
    !isEmpty(getMList) &&
    getMList.push({
      value:'All',
      label:'All',
      productQuantityCount:0,
      productPrice:0,
      piecePerBox:0,
    })
  const handleChangeProduct = (selectedOption) => {
    console.log(selectedOption, "sop");
    setProductId(selectedOption.value);
    setProductName(selectedOption.label);
  };
  useEffect(() => {
    props.setHeading("Vendor Purchase Report");
    props.getVendorData();
    props.getProduct();
  }, []);

  return (
    <>
      <Navbar style={{ backgroundColor: '#81abd3' }}  >
        <Container>
          <Navbar.Brand style={{ color: 'white' }}><b>Purchase Report</b></Navbar.Brand>
          <IconMenu />
        </Container>
      </Navbar>
      {props.isFetchingVendor || props.isFetchingProduct ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {props.isFetchingReceiving ? "Loading..." : "Loading..."}
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Breadcrumb>
                <Breadcrumb.Item ><Link to="/home"> Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
                <Breadcrumb.Item active>Purchase Report Item Wise</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <Row>
              <Col >
                <Form.Group>
                  <Form.Label>
                    <b> Start Date </b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col >
                <Form.Group>
                  <Form.Label>
                    <b> End Date</b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  >
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col >
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label>
                    <b>Select Vendor *</b>
                  </Form.Label>
                  <Select
                    isDisabled={isEmpty(props.vendorDataList)}
                    value={{ label: vendorName }}
                    placeholder="Select Vendor..."
                    onChange={handleChangeVendor}
                    options={getVendorList}
                  />
                </Form.Group>
              </Col>
              <Col >
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label>
                    <b>Select Product </b>
                  </Form.Label>
                  <Select
                    isDisabled={isEmpty(getMList) || isEmpty(vendorId)}
                    value={{ label: productName }}
                    placeholder="Select Product..."
                    onChange={handleChangeProduct}
                    // options={getVendorList}
                    options={getMList}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv">
              {isEmpty(vendorId) || startDate == '' || endDate == '' || productId == '' ? (
                <Button disabled>Generate PDF</Button>
              ) : (
                <Button onClick={uploadPurchase}>Generate PDF</Button>
              )}
            </div>
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    // getReceiving:()=>dispatch(getReceiving()),
    // getReceivingPdf:(id)=>dispatch(getPDFById(id)),
    getVendorData: () => dispatch(getVendorData()),
    generatePurchaseReportItemWise: (data) =>
      dispatch(generatePurchaseReportItemWise(data)),
    setHeading: (data) => dispatch(setHeading(data)),
    getProduct: () => dispatch(getProductData()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  // ReceivingList:state.RecivingReducer.ReceivingList,
  // isFetchingReceiving:state.RecivingReducer.isFetchingReceiving,
  purchaseVendorPDFList: state.RecivingReducer.purchaseVendorPDFList,
  isFetchingPurchaseVendorPDF:
    state.RecivingReducer.isFetchingPurchaseVendorPDF,
  vendorDataList: state.VendorReducer.vendorDataList,
  isFetchingVendor: state.VendorReducer.isFetchingVendor,
  productDataList: state.ProductReducer.productDataList,
  isFetchingProduct: state.ProductReducer.isFetchingProduct,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PurchaseVendorReport);
